/* eslint-disable @wyz/module/no-relative-import */
/* eslint-disable @wyz/i18n/no-plain-text */
import { Card, Flex, Icon } from '@wyz/ui';
import { Link } from 'react-router';
import { Trans } from '~/common/context';
import { SUPPORT_EMAIL } from '~/common/helpers';
import ErrorActions from './actions';

const Error404 = () => {
  return (
    <Card className='text-center'>
      <Card.Body className='p-5'>
        <div className='display-1 text-300 fs-error'>404</div>
        <p className='lead mt-4 text-800 font-sans-serif fw-semi-bold'>
          <Trans i18nKey='app.errors.404.title' />
        </p>
        <hr />
        <p>
          <Trans i18nKey='app.errors.404.message' />{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className='ms-1'>
            contact us
          </a>
          .
        </p>
        <Flex alignItems='center' justifyContent='center'>
          <Link className='btn btn-primary btn-sm mt-3' to='/'>
            <Icon icon={'home'} size='xs' className='me-2' />
            <Trans i18nKey='app.common.sidebar.dashboard' />
          </Link>
        </Flex>
        <ErrorActions />
      </Card.Body>
    </Card>
  );
};

export default Error404;
